import state from "./state";
export default {
  SET_COACH_TABLE(state, payload) {
    state.coachtable = payload;
  },
  SET_COACH_ANNOUNCE(state, payload) {
    state.coachannounce = payload;
  },
  EDIT_COACH_ANNOUNCE(state, payload) {
    state.coachannounce = payload;
  },
  GET_COACH_FORM(state, payload) {
    state.coachform = payload;
  },
  GET_COACH_SESSION(state, payload) {
    state.coachsession = payload;
  },
  BROACH_GET_ALL(state, payload) {
    state.borach = payload;
  },
  BROACH_DETAILS_ALL(state, payload) {
    state.borach_details = payload;
  },
};
